import { Box, Button, alpha } from "@mui/material";
import "./App.css";
import Header from "./components/Header";
import SearchAppBar from "./components/NavBar";
import { Link } from "react-router-dom";
import HighlightRecipes from "./components/HighlightRecipes";
import { Grid } from "@mui/material";
import { getDatabase, ref, child, get } from "firebase/database";
import { Helmet } from "react-helmet";

function App() {
  return (
    <div className="App">
      <div className="App-header">
        <Header sx={{}} />
        <SearchAppBar sx={{ width: "100%" }} />
        <Box
          sx={{
            width: "100%",
            bgcolor: "#282c34",
            padding: "0",
            margin: "0",
          }}
        >
          <HighlightRecipes />
        </Box>
      </div>
    </div>
  );
}

export default App;
